<template>
  <v-row>
    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 1</v-card-title>
        <v-card-subtitle>
          Visit CTrader at
          <a href="#" @click="visitCtrader">connect.spotware.com</a>
        </v-card-subtitle>
        <v-img src="@/assets/brokers/help/ctrader_step1.png"></v-img>
      </v-card>
    </v-col>
    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 2</v-card-title>
        <v-card-subtitle>Select Account(s) that you want to trade</v-card-subtitle>
        <v-img src="@/assets/brokers/help/ctrader_step1.png"></v-img>
      </v-card>
    </v-col>

    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 3</v-card-title>
        <v-card-subtitle>Check API and get account's informations</v-card-subtitle>
        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
              v-model="token"
              label="Access Token"
              :rules="[v => !!v || 'Field is required']"
              clearable
            ></v-text-field>
            <v-text-field
              v-model="refesh_token"
              label="Refresh Token"
              :rules="[v => !!v || 'Field is required']"
              clearable
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            outlined
            :loading="loading"
            :disabled="!valid"
            @click="onToken"
          >Check Token & Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { SCHEMA, ERROR } from "@/store/actions.type";
export default {
  name: "Ctrader",
  data() {
    return {
      real: false,
      valid: false,
      token: null,
      refesh_token: null,
      loading: false,
      accountDetails: [],
      accounts: []
    };
  },
  methods: {
    // mC3_UJTCcD93_Z79rqVFDrr3WyPEdD8Y43TEpcdi71s
    visitCtrader() {
      const open_url = "".concat(
        "https://connect.spotware.com/apps/auth?client_id=",
        process.env.VUE_APP_CTRADER_CLIENT_ID,
        "&redirect_uri=",
        "https://connect.spotware.com/apps/1289/playground",
        "&scope=trading"
      );
      window.open(open_url, "spotware", "width=700,height=750");
    },
    onToken() {
      this.loading = !this.loading;

      const url = "".concat(
        "https://api.spotware.com/connect/tradingaccounts?access_token=",
        this.token
      );
      const spotware = this.axios.create({
        baseURL: url
      });
      delete spotware.defaults.headers.common["Authorization"];
      spotware
        .get()
        .then(response => {
          this.accountDetails = response.data.data;
          this.convertAccounts(response.data.data);
        })
        .catch(e => {
          this.$store.dispatch(ERROR.PUSH, e.message);
        });
    },
    convertAccounts(accounts) {
      this.accounts = [];
      this.$store.dispatch(SCHEMA.GET, "account").then(result => {
        let schema = result.data;
        accounts.forEach(element => {
          let account = Object.assign({}, schema);
          account.broker = "ctrader";
          account.name = "".concat(
            element.brokerTitle,
            " [#",
            element.accountNumber,
            "]"
          );
          account.loginId = element.accountId;
          account.token = this.token;
          account.live = element.live;
          account.balance = element.balance;
          account.enable = element.accountStatus == "ACTIVE" ? true : false;
          this.accounts.push(account);
        });
        this.loading = !this.loading;
        this.$emit("accounts", this.accounts);
      });
    }
  }
};
</script>

<style>
</style>